import { render, staticRenderFns } from "./NewQuestion.vue?vue&type=template&id=2b0c20da&scoped=true&"
import script from "./NewQuestion.vue?vue&type=script&lang=ts&"
export * from "./NewQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./NewQuestion.vue?vue&type=style&index=0&id=2b0c20da&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0c20da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b0c20da')) {
      api.createRecord('2b0c20da', component.options)
    } else {
      api.reload('2b0c20da', component.options)
    }
    module.hot.accept("./NewQuestion.vue?vue&type=template&id=2b0c20da&scoped=true&", function () {
      api.rerender('2b0c20da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/groups/questions/newQuestion/NewQuestion.vue"
export default component.exports